import { withStyles } from '@material-ui/core/styles';
import { buttonBlue } from 'shared/constants/styleConstants';

const styles = theme => ({
  root: {},
  heroText: {
    fontFamily: 'Raleway',
    textAlign: 'center',
    color: 'white',
  },
  heroSubText: {
    textAlign: 'center',
    color: 'white',
    fontWeight: 500,
  },
  stepLabelDescriptionContainer: {
    paddingBottom: theme.spacing(2),
  },
  stepNumber: {
    height: '30px',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  ctaContainer: {
    paddingBottom: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(1),
    },
  },
  steps: {
    textAlign: 'center',
  },
  stepsContainer: {
    maxWidth: '500px',
  },
  stepLabelContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: '0 auto',
  },
  stepHeader: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: '16px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  stepSubText: {
    textAlign: 'center',
  },
  profile: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  heroTextContainer: {
    marginBottom: theme.spacing(2),
  },
  heroSubTextContainer: {
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  topBackground: {
    backgroundColor: buttonBlue,
  },
  heroContainer: {
    margin: '0px auto',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    maxWidth: '1000px',
  },
  howToContainer: {
    margin: '0px auto',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    maxWidth: '1000px',
  },
  getStartedContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  closeButton: {
    color: '#333',
    left: theme.spacing(0),
    top: theme.spacing(0),
    padding: theme.spacing(1, 1, 1, 1),
    margin: theme.spacing(0, 0, -1, -1),
  },
  container: {
    margin: '0px auto',
    textAlign: 'center',
    [theme.breakpoints.up('xs')]: {
      maxWidth: '500px',
      paddingTop: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '650px',
      paddingTop: theme.spacing(1),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '700px',
      paddingTop: theme.spacing(4),
      padding: theme.spacing(6),
    },
  },
  title: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    textAlign: 'left',
  },
  content: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: 0,
    },
  },
  subHeader: {
    paddingBottom: theme.spacing(3),
    textAlign: 'left',
    fontFamily: 'Raleway',
    fontWeight: 300,
    color: '#444',
    fontSize: '16px',
  },
  localLandingTitle: {
    fontSize: 45,
    [theme.breakpoints.down('sm')]: {
      fontSize: 34,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 30,
    },
    fontWeight: 'bold',
  },
  findMoreTextContainer: {
    flex: 1,
    margin: 'auto',
    paddingBottom: '10px',
    alignItems: 'center',
  },
  subtitle: {
    color: 'rgba(0, 0, 0, 0.57)',
    fontSize: 24,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 13,
    },
    fontWeight: 'bold',
    paddingTop: theme.spacing(2),
  },
  buttonContainer: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    flexDirection: 'column',
    width: 'auto',
  },
  button: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'fit-content',
    backgroundColor: '#FFA81E',
    border: 'solid',
    borderColor: '#FFA81E',
    borderRadius: '10px',
    color: '#FFF',
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 11,
    },
    fontWeight: 500,
    letterSpacing: '1.5px',
    marginBottom: '40px',
    marginTop: '-20px',
    padding: '1em',
    textAlign: 'center',
    transitionDuration: '0.4s',
    '&:active': {
      backgroundColor: 'white',
      color: '#FFA81E',
    },

    '&:focus': {
      outline: 0,
    },

    '&:hover': {
      backgroundColor: 'white',
      color: '#FFA81E',
    },
  },
});

export default withStyles(styles);
